module.exports = __webpack_public_path__ + "static/Hero-2bdd0c19e360bf8925ccf147c202ef25.mp4";